import { API, axiosInstance } from "lib";


export const deleteBannerData = (data={}) => {
    return axiosInstance
      .post(API.DELETEBANNER , data)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err) {
        }
        throw err;
      });
  };